import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { DayPicker } from 'react-day-picker';
import { format } from 'date-fns';
import Popover from 'material-ui/Popover';
import { dynamicDate } from 'config/constants';
import 'react-day-picker/src/style.css';
import './style.css';

var SlateDatePicker = function(props) {
  var value = props.value;
  var onChange = props.onChange;
  var showTime = props.showTime;
  var t = props.t;
  var disabled = props.disabled;
  // Callers that already offer "today" elsewhere (the Inspect first-due anchor select) drop
  // the quick-pick segment and keep only the date button.
  var hideToday = props.hideToday;

  var _popoverOpen = useState(false);
  var popoverOpen = _popoverOpen[0];
  var setPopoverOpen = _popoverOpen[1];

  var anchorRef = useRef(null);

  var isDynamic = value === dynamicDate;
  var parsed = !isDynamic && value ? new Date(value * 1000) : null;
  var selectedDate = parsed && !isNaN(parsed.getTime()) ? parsed : null;

  var handleTodayClick = function() {
    onChange(null, dynamicDate);
  };

  var handleSelectDateClick = function() {
    setPopoverOpen(true);
  };

  var handleDaySelect = function(date) {
    if (date) {
      onChange(null, date);
      setPopoverOpen(false);
    }
  };

  var handleClear = function(e) {
    e.stopPropagation();
    onChange(null, dynamicDate);
  };

  var handlePopoverClose = function() {
    setPopoverOpen(false);
  };

  var formatDate = function(date) {
    if (!date) return '';
    return format(date, 'MMM d, yyyy');
  };

  var todayLabel = showTime ? t('common:now') : t('common:today');
  var selectLabel = showTime ? t('settings:selectDateTime') : t('settings:selectDate');

  return (
    <div className={'slate-date-picker' + (disabled ? ' slate-date-picker--disabled' : '')}>
      <div className="slate-date-segmented" ref={anchorRef}>
        {!hideToday && (
          <button
            type="button"
            className={'slate-date-segment slate-date-segment--left' + (isDynamic ? ' slate-date-segment--active' : '')}
            onClick={handleTodayClick}
            disabled={disabled}
          >
            {todayLabel}
          </button>
        )}
        <button
          type="button"
          className={'slate-date-segment slate-date-segment--right' + (!isDynamic && !hideToday ? ' slate-date-segment--active' : '')}
          onClick={handleSelectDateClick}
          disabled={disabled}
        >
          {selectedDate ? formatDate(selectedDate) : selectLabel}
          <span className="material-symbols-outlined slate-date-segment-icon">calendar_month</span>
        </button>
        {selectedDate && (
          <button
            type="button"
            className="slate-date-clear"
            onClick={handleClear}
            disabled={disabled}
          >
            <span className="material-symbols-outlined">close</span>
          </button>
        )}
      </div>

      <Popover
        open={popoverOpen}
        anchorEl={anchorRef.current}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        targetOrigin={{ horizontal: 'left', vertical: 'top' }}
        onRequestClose={handlePopoverClose}
        className="slate-date-popover"
        style={{ marginTop: 8 }}
      >
        <DayPicker
          mode="single"
          selected={selectedDate}
          onSelect={handleDaySelect}
          captionLayout="dropdown"
          fromYear={2015}
          toYear={2035}
          defaultMonth={selectedDate || new Date()}
          showOutsideDays={false}
          fixedWeeks={false}
        />
      </Popover>
    </div>
  );
};

SlateDatePicker.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  showTime: PropTypes.bool,
  t: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  hideToday: PropTypes.bool,
};

export default SlateDatePicker;
